<template>
  <div v-if="shouldShow" class="hub-promotions-banner">
    <!-- Loading State -->
    <div v-if="loading" class="hpb-skeleton">
      <div class="hpb-skeleton-header"></div>
      <div class="hpb-skeleton-content">
        <div class="hpb-skeleton-item"></div>
        <div class="hpb-skeleton-item"></div>
        <div class="hpb-skeleton-item"></div>
        <div class="hpb-skeleton-button"></div>
      </div>
    </div>

    <!-- Content State -->
    <div v-else class="hpb-content">
      <div class="hpb-header">
        <span class="hpb-title">Ofertas Disponíveis</span>
        <p class="hpb-subtitle">
          Você possui ofertas disponíveis para este pedido.
        </p>
      </div>
      <div class="hpb-body">
        <div class="hpb-status-group">
          <div class="hpb-column hpb-column-not-started">
            <div class="hpb-icon hpb-icon-not-started">
              <i class="fa fa-circle-o"></i>
            </div>
            <div class="hpb-label">NÃO INICIADAS</div>
            <div class="hpb-count">{{ counters.notAcquired }} campanhas</div>
          </div>
          <div class="hpb-divider"></div>
          <div class="hpb-column hpb-column-partial">
            <div class="hpb-icon hpb-icon-partial">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="8"
                  cy="8"
                  r="6"
                  stroke="currentColor"
                  stroke-width="1.5"
                  fill="none"
                />
                <path d="M 2 8 A 6 6 0 1 0 14 8 L 8 8 Z" fill="currentColor" />
              </svg>
            </div>
            <div class="hpb-label hpb-label-partial">FALTA POUCO</div>
            <div class="hpb-count hpb-count-partial">
              {{ counters.partial }} campanhas
            </div>
          </div>
          <div class="hpb-divider"></div>
          <div class="hpb-column hpb-column-achieved">
            <div class="hpb-icon hpb-icon-achieved">
              <i class="fa fa-check-circle"></i>
            </div>
            <div class="hpb-label">CONQUISTADA</div>
            <div class="hpb-count">{{ counters.acquired }} campanhas</div>
          </div>
        </div>
        <div class="hpb-action">
          <button class="btn btn-link hpb-button" @click="goToCampanhas">
            Ver Ofertas <i class="fa fa-angle-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HubPromotionsBanner",
  data() {
    return {
      counterInitialized: false,
      oldTotal: 0,
    };
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    counters: {
      type: Object,
      default: () => ({
        acquired: 0,
        partial: 0,
        notAcquired: 0,
      }),
    },
  },
  computed: {
    shouldShow() {
      if (this.loading && (this.oldTotal > 0 || !this.counterInitialized))
        return true;
      const total =
        this.counters.acquired +
        this.counters.partial +
        this.counters.notAcquired;

      this.counterInitialized = true;
      this.oldTotal = total;

      return total > 0;
    },
  },
  methods: {
    goToCampanhas() {
      this.$router.push({
        name: "campanhaMain",
        query: {
          status: "partial",
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/sass/bootstrap/variables";

.hub-promotions-banner {
  margin: 0;
  padding: 8px 15px;
  background: #fff;
  border-radius: 3px;
  border: 1px solid #e5e5e5;
  transition: box-shadow 200ms ease-in;

  &:hover {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }
}

.hpb-content {
  .hpb-header {
    background: var(--brand-primary, $brand-primary);
    color: #fff;
    padding: 8px 15px;
    margin: -8px -15px 8px -15px;
    border-radius: 3px 3px 0 0;
    display: flex;
    flex-direction: column;
    gap: 3px;

    .hpb-title {
      font-family: "Open Sans";
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      line-height: 22px;
      letter-spacing: 0.02em;
    }

    .hpb-subtitle {
      font-family: "Open Sans";
      font-style: normal;
      font-weight: normal;
      font-size: 11px;
      line-height: 15px;
      color: rgba(255, 255, 255, 0.85);
      margin: 0;
    }
  }

  .hpb-body {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
  }

  .hpb-status-group {
    display: flex;
    align-items: center;
    gap: 0;
    flex: 1;
    min-width: 0;
  }

  .hpb-divider {
    width: 1px;
    height: 40px;
    background: #e5e5e5;
    flex-shrink: 0;
    margin: 0 8px;
  }

  .hpb-column {
    flex: 1;
    min-width: 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding: 4px 8px;
    transition: background-color 200ms ease-in;
    cursor: default;

    &:hover {
      background-color: #f9f9f9;
      border-radius: 3px;
    }
  }

  .hpb-icon {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    transition: transform 200ms ease-in;
    flex-shrink: 0;

    .hpb-column:hover & {
      transform: scale(1.05);
    }

    &.hpb-icon-not-started {
      background: transparent;
      color: #979797;
      border: 2px solid #e0e0e0;
    }

    &.hpb-icon-partial {
      background: transparent;
      color: $brand-warning;
      border: 2px solid $brand-warning;
      position: relative;

      svg {
        width: 14px;
        height: 14px;
        display: block;
      }
    }

    &.hpb-icon-achieved {
      background: $brand-success;
      color: #fff;
      border: 2px solid $brand-success;
    }
  }

  .hpb-label {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.03em;
    color: #6d6d6d;
    text-transform: uppercase;

    &.hpb-label-partial {
      font-weight: 700;
      color: $brand-warning;
    }
  }

  .hpb-count {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    line-height: 18px;
    letter-spacing: 0.02em;
    color: #737373;

    &.hpb-count-partial {
      color: $brand-warning;
      font-weight: 700;
      font-size: 14px;
    }
  }

  .hpb-action {
    flex-shrink: 0;
    display: flex;
    align-items: center;
  }
}

// Skeleton Styles
.hpb-skeleton {
  .hpb-skeleton-header {
    height: 45px;
    background: #e3e3e3;
    border-radius: 3px;
    margin-bottom: 8px;
    animation: skeleton-loading 1.3s ease-in-out infinite;
  }

  .hpb-skeleton-content {
    display: flex;
    gap: 12px;
    align-items: center;
  }

  .hpb-skeleton-item {
    flex: 1;
    height: 50px;
    background: #e3e3e3;
    border-radius: 3px;
    animation: skeleton-loading 1.3s ease-in-out infinite;
  }

  .hpb-skeleton-button {
    width: 120px;
    height: 36px;
    background: #e3e3e3;
    border-radius: 3px;
    animation: skeleton-loading 1.3s ease-in-out infinite;
  }
}

@keyframes skeleton-loading {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 1200px 0;
  }
}

.hpb-skeleton-header,
.hpb-skeleton-item,
.hpb-skeleton-button {
  background: #e3e3e3;
  background-image: linear-gradient(
    to left,
    #e2e2e2 0%,
    #c1c1c1 20%,
    #dedede 40%,
    #e1e1e1 100%
  );
  background-repeat: no-repeat;
  background-size: 800px 100%;
  animation: skeleton-loading 1.3s ease-in-out infinite;
}

// Responsividade Mobile
@media (max-width: 420px) {
  .hub-promotions-banner {
    padding: 8px 12px;
  }

  .hpb-content {
    .hpb-header {
      padding: 6px 12px;
      margin: -8px -12px 6px -12px;
      gap: 2px;

      .hpb-title {
        font-size: 15px;
        line-height: 20px;
      }

      .hpb-subtitle {
        font-size: 10px;
        line-height: 14px;
      }
    }

    .hpb-body {
      flex-direction: column;
      gap: 12px;
      align-items: stretch;
    }

    .hpb-status-group {
      width: 100%;
      justify-content: space-around;
    }

    .hpb-divider {
      height: 32px;
      margin: 0 4px;
    }

    .hpb-column {
      padding: 4px 4px;
      gap: 3px;
      min-width: 0;
      flex: 1;
    }

    .hpb-icon {
      width: 28px;
      height: 28px;
      font-size: 12px;

      &.hpb-icon-partial {
        svg {
          width: 12px;
          height: 12px;
        }
      }
    }

    .hpb-label {
      font-size: 10px;
      line-height: 14px;
    }

    .hpb-count {
      font-size: 12px;
      line-height: 16px;
      font-weight: 600;

      &.hpb-count-partial {
        font-size: 13px;
        font-weight: 700;
      }
    }

    .hpb-action {
      width: 100%;
      margin-top: 4px;
    }

    .hpb-button {
      width: 100%;
      justify-content: center;
      padding: 10px 16px;
      height: 40px;
    }
  }
}
</style>
